export const GET_CVS = "GET_CVS";
export const ADD_CV = "ADD_CV";
export const EDIT_CV = "EDIT_CV";
export const GET_CV = "GET_CV";
export const RESET_CV = "RESET_CV";
export const ERROR_CV = "ERROR_CV";
export const GET_ALL_CVS = "GET_ALL_CVS";
                